import React from 'react';
import CaseList from '../CaseList';
import styles from './../CaseList.module.scss';
import useCases from '../../../Hooks/useCases';
import { useLazyWorkplaceCasesQuery } from '../../../../../graphql/graphql';
import WorkplaceCasesFilter from './WorkplaceCasesFilter';
import CaseListItem from '../CaseListItem';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import useSocket from '../../../../Base/Hooks/useSocket';
import { Socket } from '../../../../Base/Enums/Socket.enum';

const WorkplaceCasesList: React.FC = () => {
	const [getWorkplaceCasesQuery, { data, isLoading }] =
		useLazyWorkplaceCasesQuery();
	const { getWorkplaceCases, getNextPage, page, setPage } = useCases(
		getWorkplaceCasesQuery,
	);

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getWorkplaceCases,
		{
			data: data?.workplaceCases?.data,
			totalPages: data?.workplaceCases?.meta?.totalPages,
			page: data?.workplaceCases?.meta?.page,
		},
		page,
		setPage,
	);

	useSocket(Socket.CASE_TAKEN, loadData);

	return (
		<div className={styles.wrapper}>
			<WorkplaceCasesFilter onFilter={filter => setFilter(filter)} />
			<CaseList
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={() => loadData(true)}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				renderItem={item => (
					<CaseListItem
						onRefresh={() => loadData(true)}
						item={item}
						showAssignedDoctor
					/>
				)}
			/>
		</div>
	);
};

export default WorkplaceCasesList;
